import { CoreIcon } from '../core-icon';
import loadingSVG from '../../assets/icons/loading.svg';
import type { IconProps } from '../core-icon';

export const LoadingIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={loadingSVG} {...props} />;
};
